<template>
  <svg :width="size" :height="size" viewBox="0 0 17 17"
       fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 8.25C15 4.52208 11.9779 1.5 8.25 1.5C4.52208 1.5 1.5 4.52208 1.5 8.25C1.5 11.9779 4.52208 15 8.25 15C11.9779 15 15 11.9779 15 8.25ZM8.25732 11.25C8.67154 11.25 9.00732 11.5858 9.00732 12C9.00732 12.4142 8.67154 12.75 8.25732 12.75H8.25C7.83579 12.75 7.5 12.4142 7.5 12C7.5 11.5858 7.83579 11.25 8.25 11.25H8.25732ZM6.67017 4.16016C7.28093 3.80126 7.9993 3.66979 8.69751 3.78955C9.39571 3.90936 10.0291 4.27299 10.4854 4.81494C10.9412 5.35661 11.1907 6.04204 11.1899 6.75C11.1899 7.89815 10.3388 8.65632 9.73096 9.06152C9.40425 9.27932 9.08293 9.43971 8.84619 9.54492C8.72689 9.59794 8.6264 9.63817 8.55396 9.66577C8.51775 9.67957 8.48821 9.69038 8.4668 9.698C8.45608 9.70181 8.44703 9.70452 8.44043 9.70679C8.43722 9.70789 8.43456 9.70897 8.43237 9.70972C8.43127 9.71009 8.43028 9.7109 8.42944 9.71118H8.42798C8.42775 9.71126 8.42711 9.71151 8.18994 9L8.42725 9.71191C8.03436 9.84282 7.60979 9.63015 7.47876 9.2373C7.34781 8.84445 7.55988 8.41993 7.95264 8.28882L7.96436 8.28442C7.97592 8.28031 7.99502 8.27344 8.02002 8.26392C8.07057 8.24465 8.14552 8.2144 8.23682 8.17383C8.42193 8.09156 8.66317 7.97064 8.89893 7.81348C9.41613 7.46868 9.68994 7.10185 9.68994 6.75V6.74927C9.69047 6.39511 9.56567 6.05198 9.33765 5.78101C9.10952 5.51 8.7925 5.3282 8.44336 5.26831C8.09431 5.20851 7.73501 5.27418 7.42969 5.45361C7.12444 5.63311 6.89241 5.91497 6.7749 6.24902C6.6374 6.63969 6.20906 6.84496 5.81836 6.70752C5.42781 6.56995 5.22244 6.14162 5.35986 5.75098C5.59498 5.0827 6.0594 4.51911 6.67017 4.16016ZM16.5 8.25C16.5 12.8063 12.8063 16.5 8.25 16.5C3.69365 16.5 0 12.8063 0 8.25C0 3.69365 3.69365 0 8.25 0C12.8063 0 16.5 3.69365 16.5 8.25Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'HelpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 11
    },
    fill: {
      type: String,
      default: '#62676D'
    }
  }
};
</script>